import { EdgeProps, getSmoothStepPath } from "@xyflow/react";
import { motion } from "framer-motion";
import useOrgchartEmployeesStore from "src/Pages/Company/OrganizationStructure/ConfigureStructure/Tabs/StructureView/Employees/store";

const EmployeeEdge = ({
  id,
  sourceX,
  sourceY,
  targetX,
  targetY,
  markerEnd,
  target,
}: EdgeProps) => {
  const { visibleNodesRef } = useOrgchartEmployeesStore();
  const isInView = visibleNodesRef.get(target) || false;

  if (isInView) {
    return (
      <motion.path
        d={
          getSmoothStepPath({
            sourceX,
            sourceY,
            targetX,
            targetY,
            borderRadius: 200,
          })[0]
        }
        fill="none"
        id={id}
        stroke="#C6D4E3"
        strokeWidth={3}
        markerEnd={markerEnd}
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 0.4 }}
      />
    );
  }

  return null;
};

export default EmployeeEdge;
